import { render, staticRenderFns } from "./ProjectMaterialForm.vue?vue&type=template&id=149a4914"
import script from "./ProjectMaterialForm.vue?vue&type=script&lang=js"
export * from "./ProjectMaterialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports